import React from 'react';

import { Box, Table } from '@betterment/samba-react';

import { BillingPlanTableColumn } from '../data';

const BillingPlanTableHeaderCell: React.FC<{
  column: BillingPlanTableColumn;
  tooltip: React.ReactNode;
}> = ({ column, tooltip }) => {
  return (
    <Table.ColumnHeaderCell
      css={{
        p: '0',
        pt: 'space.150',
        pr: 'space.150',
        pb: 'space.150',
        borderBottomStyle: 'solid',
        borderBottomColor: 'border.weak',
        borderBottomWidth: '.1rem',
        ...column.css,
      }}
    >
      <Box css={{ display: 'inline-flex' }}>
        {column.name} {tooltip}
      </Box>
    </Table.ColumnHeaderCell>
  );
};
export default BillingPlanTableHeaderCell;
